<template>
  <div id="app">
    <Header></Header>
    <main class="main-content">
      <transition name="page-fade" mode="out-in">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
      </transition>
      <transition name="page-fade" mode="out-in">
        <router-view v-if="!$route.meta.keepAlive" />
      </transition>
    </main>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
html {
  overflow: "-moz-hidden-unscrollable";
  height: 100%;
  scroll-behavior: smooth;
}

body {
  font-family: var(--font-family);
  font-size: var(--font-size-base);
  line-height: var(--line-height-normal);
  color: var(--text-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

body::-webkit-scrollbar {
  width: 6px;
}

body::-webkit-scrollbar-thumb {
  background: rgba(19, 88, 254, 0.3);
  border-radius: 3px;
}

body::-webkit-scrollbar-track {
  background: transparent;
}

.main-content {
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue